import { parseColorVision } from "../theme/themePreference";

export const COLOR_VISION_FILTERS_SVG_ID = "licenciar-color-vision-filters";
export const COLOR_VISION_ATTRIBUTE = "data-color-vision";

export const COLOR_VISION_FILTER_IDS = Object.freeze({
  protanopia: "licenciar-cv-protanopia",
  deuteranopia: "licenciar-cv-deuteranopia",
  tritanopia: "licenciar-cv-tritanopia",
});

export const COLOR_VISION_MATRICES = Object.freeze({
  // Aproximação Wickline/Colorjack (simulação CSS; não é diagnóstico clínico).
  protanopia:
    "0.567 0.433 0 0 0 0.558 0.442 0 0 0 0 0.242 0.758 0 0 0 0 0 1 0",
  deuteranopia: "0.625 0.375 0 0 0 0.7 0.3 0 0 0 0 0.3 0.7 0 0 0 0 0 1 0",
  tritanopia: "0.95 0.05 0 0 0 0 0.433 0.567 0 0 0 0.475 0.525 0 0 0 0 0 1 0",
});

export function getColorVisionCssFilter(mode) {
  const parsed = parseColorVision(mode);
  if (parsed === "off") {
    return "none";
  }
  return `url(#${COLOR_VISION_FILTER_IDS[parsed]})`;
}

function ensureColorVisionFilterSvg() {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById(COLOR_VISION_FILTERS_SVG_ID)) {
    return;
  }

  const ns = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(ns, "svg");
  svg.setAttribute("id", COLOR_VISION_FILTERS_SVG_ID);
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  svg.style.cssText =
    "position:absolute;width:0;height:0;overflow:hidden;pointer-events:none;";

  Object.entries(COLOR_VISION_MATRICES).forEach(([mode, values]) => {
    const filter = document.createElementNS(ns, "filter");
    filter.setAttribute("id", COLOR_VISION_FILTER_IDS[mode]);
    filter.setAttribute("color-interpolation-filters", "sRGB");
    const matrix = document.createElementNS(ns, "feColorMatrix");
    matrix.setAttribute("type", "matrix");
    matrix.setAttribute("values", values);
    filter.appendChild(matrix);
    svg.appendChild(filter);
  });

  const host = document.body || document.documentElement;
  host.appendChild(svg);
}

export function applyDocumentColorVision(mode) {
  if (typeof document === "undefined") {
    return parseColorVision(mode);
  }

  const parsed = parseColorVision(mode);
  const root = document.documentElement;

  if (parsed === "off") {
    root.removeAttribute(COLOR_VISION_ATTRIBUTE);
    root.style.removeProperty("filter");
    return parsed;
  }

  ensureColorVisionFilterSvg();
  root.setAttribute(COLOR_VISION_ATTRIBUTE, parsed);
  root.style.filter = getColorVisionCssFilter(parsed);
  return parsed;
}

export function stripColorVisionFilterFromClone(clonedDocument) {
  if (!clonedDocument) {
    return;
  }

  const root = clonedDocument.documentElement;
  if (root) {
    root.removeAttribute(COLOR_VISION_ATTRIBUTE);
    root.style.setProperty("filter", "none", "important");
  }

  if (clonedDocument.body) {
    clonedDocument.body.style.setProperty("filter", "none", "important");
  }

  clonedDocument.querySelectorAll?.(`[${COLOR_VISION_ATTRIBUTE}]`).forEach((element) => {
    element.removeAttribute(COLOR_VISION_ATTRIBUTE);
    element.style.setProperty("filter", "none", "important");
  });

  clonedDocument.getElementById(COLOR_VISION_FILTERS_SVG_ID)?.remove();
}

export async function withColorVisionFilterDisabled(task) {
  if (typeof document === "undefined") {
    return task();
  }

  const previousMode = parseColorVision(
    document.documentElement.getAttribute(COLOR_VISION_ATTRIBUTE),
  );
  applyDocumentColorVision("off");
  try {
    return await task();
  } finally {
    applyDocumentColorVision(previousMode);
  }
}
